import { render } from "./Card.vue?vue&type=template&id=8db3d164"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=8db3d164&lang=scss"

import exportComponent from "/root/tools-store-ranking-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__